const modulo_users = {
	strict: false,

	state:{
		users:[],
		formaciones_expired:[]
	},

	getters: {
		getusers: state => state.users,
		getFormacionesExpired: state => state.formaciones_expired,
	},

	mutations: {
		get_users: (state, users) => {
			state.users = users
		},
		get_formaciones_expired: (state, formaciones_expired) => {
			state.formaciones_expired = formaciones_expired
		},
		remove_formacion_expired: (state, formacion_id) => {
			state.formaciones_expired = state.formaciones_expired.filter(f => f.id !== formacion_id)
		},
	},

	actions: {
		getUsers: (context, vm) => {
			axios.get('api/get-usuarios').then(res => {        
				context.commit('get_users', res.data)
			}, res => {
				console.error("Error en getUsers:", error);
			})
		},
		getFormacionesExpired: (context, vm) => {
			axios.get('api/empleado/formaciones/expired').then(res => {        
				context.commit('get_formaciones_expired', res.data)
			}, res => {
				console.error("Error en getFormacionesExpired:", error);
			})
		}
	}
}

export default modulo_users;
